// Core Components Module
// Import all core custom components - these will register themselves

import './page-head.ts';
import './dammi-header.ts';
import './dammi-footer.ts';
import './dammi-lang-switcher.ts';
import './dammi-text.ts';
import './hero-section.ts';
import './cta-section.ts';
import './association-card.ts';

console.log('Core components loaded');

